import { ComponentType } from 'react';

import { PageProgress } from '@src/components/common/page-progress';
import { ToastContainer } from '@src/components/molecules/toast-container';
import { DynamicScripts } from '@src/components/scripts/dynamic/dynamic-scripts';
import { usePageTracking } from '@src/features/analytics/hooks';
import { AuthProvider } from '@src/features/auth/contexts/auth-context';
import { ProfileProvider } from '@src/features/profile/contexts/profile-context';
import { FirstPartyConsentSync } from '@src/features/user-consent/components/first-party-consent-sync';
import { useSetAuthTokenInHttpHeaders } from '@src/hooks/use-auth-token';
import { BrandData, CommonData } from '@src/lib/ssr/types';

import AuthLayoutFooter from './auth-layout-footer';
import AuthLayoutHeader from './auth-layout-header';
import AuthLayoutMain from './auth-layout-main';
import { Wrapper } from './styles';

const AuthLayout = <T extends Record<string, unknown>>(Component: ComponentType<T>) => {
  const ComponentWithProviders = (props: T & CommonData & BrandData) => {
    const { profileCache } = props;

    useSetAuthTokenInHttpHeaders();
    usePageTracking();

    return (
      <>
        <DynamicScripts />

        <AuthProvider>
          <ProfileProvider profileCache={profileCache ?? undefined}>
            <FirstPartyConsentSync />
            <Wrapper>
              <Component {...props} />

              <PageProgress />

              <ToastContainer />
            </Wrapper>
          </ProfileProvider>
        </AuthProvider>
      </>
    );
  };
  ComponentWithProviders.displayName = Component.displayName;

  return ComponentWithProviders;
};
AuthLayout.Main = AuthLayoutMain;
AuthLayout.Header = AuthLayoutHeader;
AuthLayout.Footer = AuthLayoutFooter;
export default AuthLayout;
